<template>
  <div class=" h-full">
    <el-card class="h-full" :body-style="{ height: '100%', padding: '20px' }">
      <div class="flex items-center">
        <el-input
          v-model="searchCode"
          class="w-200px"
          placeholder="编码"
          size="small"
          clearable
        ></el-input>
        <el-input
          v-model="searchName"
          class="w-200px ml-10px mr-10px"
          placeholder="名称"
          size="small"
          clearable
        ></el-input>
        <el-button type="primary" size="small" @click="searchResult">搜索</el-button>
        <el-button size="small" @click="resetSearch">重置</el-button>
        <el-button
          type="primary"
          size="small"
          :disabled="!$hasAccess('create')"
          @click="openOperate(0, null)"
          >新增</el-button
        >
        <el-button
          type="danger"
          size="small"
          :disabled="!$hasAccess('delete')"
          @click="deleteDatas(selectionIds)"
          >删除</el-button
        >
      </div>
      <div class="h-[calc(100%-104px)] mt-20px" v-loading="listLoading">
        <el-table
          ref="tableList"
          :data="dataList"
          height="100%"
          :stripe="true"
          border
          row-key="id"
          @selection-change="selectionChange"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="selection"
            reserve-selection
            width="55px"
          >
          </el-table-column>
          <el-table-column
            prop="seqNo"
            label="序号"
            header-align="center"
            align="center"
            width="125px"
          >
          </el-table-column>
          <el-table-column prop="code" label="编码" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="name" label="名称" show-overflow-tooltip> </el-table-column>
          <el-table-column label="操作">
            <template #default="{row}">
              <el-button size="mini" @click="openOperate(2, row)">查看</el-button>
              <el-button size="mini" @click="openOperate(1, row)">编辑</el-button>
              <el-button size="mini" @click="deleteDatas([row.id])">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="getDataList"
          @size-change="searchResult"
          class="mt-20px float-right"
          small
          background
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :page-size.sync="pageSize"
          :current-page.sync="pageNo"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
        >
        </el-pagination>
      </div>
      <OperateDialog
        v-if="operateConfig.visible"
        :config="operateConfig"
        @close="operateClose"
        @operateSuccess="searchResult"
      ></OperateDialog>
    </el-card>
  </div>
</template>

<script>
import { CockpitApi } from '@wiz-api/cloud-render-management'

const OperateDialog = () => {
  return import('../components/CockpitManagement/OperateDialog')
}

const cockpitApi = new CockpitApi()

export default {
  components: { OperateDialog },
  data() {
    return {
      searchCode: '',
      searchName: '',
      dataList: [],
      pageSize: 15,
      pageNo: 1,
      pageTotal: 0,
      listLoading: false,
      operateConfig: {
        visible: false,
        title: '',
        type: '',
        data: null,
      },
      selectionIds: [],
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    // 多选列表
    selectionChange(rows) {
      this.selectionIds = _.map(rows, 'id')
    },
    // 删除数据
    deleteDatas(ids) {
      if (!ids.length) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm('删除后将无法恢复, 确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err, res] = await cockpitApi.deleteMany({ ids })
        if (!err) {
          this.selectionIds = []
          this.$refs.tableList.clearSelection()
          this.searchResult()
          this.$message.success('删除成功')
        }
      })
    },
    // 关闭操作弹框
    operateClose() {
      this.operateConfig = this.$options.data().operateConfig
    },
    // 获取列表数据
    async getDataList() {
      const parmas = {
        code: this.searchCode,
        name: this.searchName,
        sorting: 'seqNo',
        maxResultCount: this.pageSize,
        skipCount: (this.pageNo - 1) * this.pageSize,
      }
      this.listLoading = true
      const [err, res] = await cockpitApi.getList(parmas)
      this.listLoading = false
      if (!err) {
        this.dataList = res.items
        this.pageTotal = res.totalCount
      }
    },
    // 搜索
    searchResult() {
      this.pageNo = 1
      this.getDataList()
    },
    // 重置
    resetSearch() {
      this.searchCode = ''
      this.searchName = ''
      this.searchResult()
    },
    // 打开操作框
    openOperate(type, data) {
      if (type === 0) {
        this.operateConfig.visible = true
        this.operateConfig.title = '新增'
        this.operateConfig.type = 'add'
      } else if (type === 1) {
        this.operateConfig.visible = true
        this.operateConfig.title = '编辑'
        this.operateConfig.type = 'edit'
        this.operateConfig.data = data
      } else if (type === 2) {
        this.operateConfig.visible = true
        this.operateConfig.title = '详情'
        this.operateConfig.type = 'detail'
        this.operateConfig.data = data
      }
    },
  },
}
</script>

<style></style>
